export function formatarCelular(valor: string): string {
  const digitos = valor.replace(/\D/g, '').slice(0, 11);

  if (digitos.length <= 2) return digitos.replace(/^(\d*)/, '($1');
  if (digitos.length <= 7) return digitos.replace(/^(\d{2})(\d*)/, '($1) $2');
  return digitos.replace(/^(\d{2})(\d{5})(\d*)/, '($1) $2-$3');
}

export function formatarCep(valor: string): string {
  const digitos = valor.replace(/\D/g, '').slice(0, 8);

  if (digitos.length <= 5) return digitos;
  return digitos.replace(/^(\d{5})(\d{0,3})$/, '$1-$2');
}
